import { formatarReais } from '@du/shared'
import { cn } from '../lib/cn.js'

/**
 * Linha de cardápio com pontilhado entre nome e preço — "Lista de cardápio ·
 * pontilhado preto" do guia. O pontilhado é borda CSS, não caractere
 * repetido: funciona em qualquer largura sem contar colunas.
 */
export type MenuRowProps = {
  nome: string
  ingredientes?: string | null | undefined
  precoCents: number
  esgotado?: boolean | undefined
  onClick?: () => void | undefined
  className?: string | undefined
}

export function MenuRow({ nome, ingredientes, precoCents, esgotado, onClick, className }: MenuRowProps) {
  const Tag = onClick ? 'button' : 'div'
  return (
    <Tag
      {...(onClick ? { type: 'button' as const, onClick, disabled: esgotado } : {})}
      className={cn('du-linha', esgotado && 'du-linha--esgotado', onClick && 'du-linha--clicavel', className)}
    >
      <span className="du-linha__corpo">
        <span className="du-linha__topo">
          <span className="du-linha__nome">{nome}</span>
          <span className="du-linha__pontilhado" aria-hidden />
          <span className="du-linha__preco">{formatarReais(precoCents)}</span>
        </span>
        {ingredientes ? <span className="du-linha__ingredientes">{ingredientes}</span> : null}
      </span>
      {esgotado ? <span className="du-linha__esgotado">ESGOTADO</span> : null}
    </Tag>
  )
}
